import { JsonApiRequestError } from '@farfetched/core';
import { Store, StoreWritable } from 'effector';
import {
	createGameSettingRegistryQuery,
	GameSettingRegistryFilters,
	GameSettingWithId,
	Setting,
} from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel } from 'shared/lib';

export type CreateGameSettingRegistryParams = {
	$currencies: StoreWritable<string[]>;
	$gameId: Store<number | null>;
	$accountId?: Store<number | null>;
} & RegistryCallbacks;

export type GameSettingRegistryModel = {
	model: RegistryModel<GameSettingWithId, GameSettingRegistryFilters, JsonApiRequestError>;
	$currencies: StoreWritable<string[]>;
	$settings: Store<Setting[]>;
};

export const createGameSettingRegistryModel = ({
	$currencies,
	$gameId,
	$accountId,
	...params
}: CreateGameSettingRegistryParams): GameSettingRegistryModel => {
	const query = createGameSettingRegistryQuery({ $gameId, $accountId });

	const model = createRegistryModel({
		query,
		filters: {
			currencies: [],
			accountIds: [],
		},
		...params,
	});

	const $settings = query.$data.map((result) =>
		result
			? Object.values(
					result.rows
						.map((row) => row.settings)
						.reduce(
							(acc, settings) => {
								settings.forEach((setting) => {
									acc[setting.code] = setting;
								});

								return acc;
							},
							{} as Record<string, Setting>,
						),
				)
			: [],
	);

	return { model, $currencies, $settings };
};
